// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PvH8","icon":"styles_icon__3ZWBC"};